<template>
  <div class="student-response-details">
    <el-form style="max-height: 500px; overflow: auto" v-if="studentSurveyResponse">
      <!-- <div class="written">
        <span>填写人：{{ studentSurveyResponse.studentName }}</span>
      </div> -->
      <el-form-item v-for="(item, index) in studentSurveyResponse.surveyOptionsList" :key="index"
        :label="(index + 1) + '.' + item.title" :label-position="labelPosition"
        :required="item.isRequired == '1' ? true : false" style="text-align: left">
        <el-image v-if="item.problemType == '5'" style="width: 100px; height: 100px" :src="item.answerContent"
          :preview-src-list="[item.answerContent]" fit="scale-down"></el-image>
        <span class="form-item-text" v-else>{{ item.answerContent || '无' }}</span>
      </el-form-item>
    </el-form>
    <!-- <el-button type="primary" @click="back">返回</el-button> -->
  </div>
</template>

<script>
export default {
  props: ["studentSurveyResponse", "mode"],
  data() {
    return {
      labelPosition: "top",
    };
  },
  methods: {
    back() {
      this.$emit("update:mode", "table");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./studentResponseDetails.scss";
</style>